module.exports = __webpack_public_path__ + "010c1aeee3c6d1cbb1d5761d80353823.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-700italic.woff2
// module id = 673
// module chunks = 0